import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';
import Maintenance from './Maintenance';

/**
 * Component to check platform status and show maintenance page if closed
 * Should wrap routes that need platform to be open
 */
function PlatformStatusCheck({ children }) {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Routes that require platform to be open (pre-registration routes are always allowed)
  const protectedRoutes = ['/login', '/register', '/supplier/login', '/supplier/register'];

  useEffect(() => {
    const checkPlatformStatus = async () => {
      // Only check for protected routes
      const isProtectedRoute = protectedRoutes.some(route => 
        location.pathname === route || location.pathname.startsWith(route)
      );

      if (!isProtectedRoute) {
        setLoading(false);
        return;
      }

      try {
        const response = await api.get('/api/public/platform-status');
        const isCoupleRoute = location.pathname === '/login' || location.pathname === '/register';
        const _isSupplierRoute = location.pathname === '/supplier/login' || location.pathname === '/supplier/register';
        const open = isCoupleRoute ? (response.data.coupleOpen !== false) : (response.data.supplierOpen !== false);
        setIsOpen(open);
      } catch (error) {
        setIsOpen(true);
      } finally {
        setLoading(false);
      }
    };

    checkPlatformStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- verified intentional deps
  }, [location.pathname]);

  if (loading) {
    return null; // Or a loading spinner
  }

  // Check if current route is protected
  const isProtectedRoute = protectedRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(route)
  );

  if (isProtectedRoute && !isOpen) {
    return <Maintenance />;
  }

  return children;
}

export default PlatformStatusCheck;

